module.exports = __webpack_public_path__ + "static/img/sas-new-icon-en.4c93b038.png";